import { COLORS } from '@/constants';
import { Link } from '@/config/i18n/navigation';
import styled from 'styled-components';

export const LinkBoxWrapper = styled.section`
  width: 100%;
  background-color: ${COLORS['neutral/100']};
  padding: 32px 0 40px;
`;

export const LinkBoxContainer = styled.div`
  max-width: 1330px;
  margin: 0 auto;
  padding: 0 50px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const TabsWrapper = styled.div`
  margin-bottom: 24px;
  overflow-x: auto;

  @media (max-width: 768px) {
    overflow-x: visible;
  }
`;

export const ColumnsGrid = styled.div<{ $columnCount: number; $hidden?: boolean }>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'grid')};
  grid-template-columns: repeat(${({ $columnCount }) => $columnCount}, minmax(0, 1fr));
  align-items: start;
  gap: 24px 32px;

  @media (max-width: 1020px) {
    grid-template-columns: repeat(
      ${({ $columnCount }) => Math.min($columnCount, 2)},
      minmax(0, 1fr)
    );
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ColumnSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ColumnTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  color: ${COLORS['primary/900']};
  margin-bottom: 4px;
`;

export const LinkList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LinkItem = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ChevronIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  color: ${COLORS.orange};
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
`;

export const SeoLinkStyled = styled(Link).attrs({ prefetch: false })`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.orange};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: ${COLORS['secondary/700']};
  }
`;
